document.addEventListener( 'DOMContentLoaded', function() {
  document.addEventListener( 'keydown', function( event ) {
    if ( event.key === 'Escape' ) {
      $.fancybox.close();
    }
  } );
} );